import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Sidebar from "./components/Sidebar";
import { WealthProvider } from "./components/WealthContext";
import Login from "./pages/Login";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./pages/PrivateRoute";
import Account from "./pages/Account";
import SignUp from "./pages/SignUp";
import LandingPage from "./pages/LandingPage";
import HabitTracker from "./components/HabitTracker";
import MobileBar from "./components/MobileBar";
import { useEffect, useState } from "react";
import DailyToDo from "./components/DailyToDo";

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 840);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 922);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <AuthProvider>
      <WealthProvider>
        <div className="App">
          {isMobile ? <MobileBar /> : <Sidebar />}
          {/* <Sidebar /> */}
          <Routes>
            <Route path="/signup" element={<SignUp />} />
            <Route path="/ht" element={<HabitTracker />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/app"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path="/tasks"
              element={
                <PrivateRoute>
                  <DailyToDo />
                </PrivateRoute>
              }
            />
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <Account />
                </PrivateRoute>
              }
            />
            {/* <Route path="/" element={<Home />} /> */}
          </Routes>
          {/* <MobileBar /> */}
        </div>
      </WealthProvider>
    </AuthProvider>
  );
}

export default App;
